<template>
  <div class="rest-categories">
    <div class="row my-3">
      <div class="col-12">
        <h2 class="">{{ $t('restCategories.categories') }}
          <div v-show="this.LOADING.categories" class="spinner-border spinner-border-sm h4 fw-normal text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6 pb-4">
        <div class="row my-4 mt-0 pb-2 justify-content-between justify-content-lg-start">
          <div class="col-8 col-md-6">
            <label for="restTitle" class="form-label">{{ $t('restCategories.addCategoryTitle') }}</label>
            <input v-model.trim="this.newCategory" type="text" class="form-control" id="newCategory"
                   :placeholder="$t('restCategories.categoryTitle')">
          </div>
          <div class="col-3 d-flex align-items-end text-end text-lg-start">
            <span class="d-inline-block" :data-bs-toggle="this.newCategory.length === 0 && !this.LOADING.categories ? 'tooltip' : ''" 
                  data-bs-placement="top" :data-bs-title="$t('restCategories.titleFirst')">
              <button 
                  @click="this.addCategory"
                  :disabled="this.newCategory.length < 3 || this.doubleCategory"
                  class="btn btn-outline-success pt-1">
                  {{ $t('restCategories.addCategoryBtn') }}
              </button>
            </span>
          </div>
          <div v-show="this.doubleCategory" class="col-12 mb-0">
            <p class="pt-1 mb-0 fst-italic text-danger">{{ $t('restCategories.categoryAlreadyExists') }}</p>
          </div>
        </div>
        <div class="list-group category-list">
          <div v-for="(category, index) in this.restaurantCategories"
              :key="category"
              class="category-list__item d-flex justify-content-between align-items-center list-group-item list-group-item-action pt-1 pb-0">
            <div class="d-flex">
              <span v-if="index !== edit" class="d-flex align-items-center">{{ category }}</span>
              <input v-else v-model.trim="this.editedCategory" type="text" class="form-control mb-1" @keydown.enter="this.addCategory">
              <span class="text-muted m-2">({{this.countProductToCategory(category)}})</span>
              <button
                  v-show="index != 0"
                  v-if="index !== edit"
                  @click="this.editCategoryName(index, category)"
                  class="btn-change-cat-position btn btn-outline-secondary p-1 m-2" style="line-height: 1px"
                  :class="this.edit ? 'invisible': ''">
                <svg width="1rem" height="1rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#pencil-fill"/>
                </svg>
              </button>
              <button
                  v-show="index == edit"
                  v-else
                  @click="this.addCategory"
                  :disabled="this.editedCategory.length < 3 || this.doubledCategory"
                  class="btn btn-outline-success p-1 m-2" style="line-height: 1px">
                <svg width="1rem" height="1rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#check-lg"/>
                </svg>
              </button>
              <button
                  v-show="index == edit"
                  @click="this.cancellBtn"
                  class="btn btn-outline-secondary p-1 mr-0 ml-2 mt-2 mb-2" style="line-height: 1px">
                <svg width="1rem" height="1rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#x"/>
                </svg>
              </button>
            </div>
            <div>
              <button
                  v-show="index != 1"
                  @click="this.changeCategoryPosition(index, category, 'up')"
                  class="btn-change-cat-position btn btn-outline-secondary p-1 me-2" style="line-height: 1px" 
                  :class="this.edit ? 'invisible': ''">
                <svg width="1rem" height="1rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#arrow-up"/>
                </svg>
              </button>
              <button
                  v-show="index != countCategories"
                  @click="this.changeCategoryPosition(index, category, 'down')"
                  class="btn-change-cat-position btn btn-outline-secondary p-1 me-2" style="line-height: 1px" 
                  :class="this.edit ? 'invisible': ''">
                <svg width="1rem" height="1rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#arrow-down"/>
                </svg>
              </button>
              <button
                  @click="this.removeCategory(index)"
                  class="btn btn-outline-danger pt-0 p-1">
                <svg width="1rem" height="1rem" fill="currentColor">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#trash3-fill"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import router from "@/router";
import {Tooltip} from "bootstrap";
import i18n from "@/i18n";
import _ from 'lodash'

export default {
  name: "Categories",
  data() {
    return {
      newCategory: '',
      doubleCategory: false,
      doubledCategory: false,
      edit: false,
      editedCategory: '',
    }
  },
  computed: {
    ...mapGetters([
      'RESTAURANT',
      'RESTAURANTMENU',
      'LOADING',
    ]),
    restaurantCategories() {
      if(this.RESTAURANT.settings) {
        return this.RESTAURANT.settings.category_sequence
      }
    },
    countCategories() {
      return Object.values(this.RESTAURANT.settings['category_sequence']).length
    }
  },
  methods: {
    countProductToCategory(category) {
      let n = 0;
      let menu = this.RESTAURANTMENU;
      for(let key in menu) {
        if(menu[key].category === category) { n++ }
      }
      return n;
    },
    sameCategories(elem) {
      return this.newCategory.toLowerCase() === elem.toLowerCase()
    },
    updateCategory(newCategories) {
      let data = {settings: {category_sequence: newCategories}}
      let restId = this.$route.params.id
      let payload = {restId, data}
      this.$store.dispatch('addRestaurantCategory', payload)
    },
    addCategory() {
      let categories = this.RESTAURANT.settings['category_sequence']
      let newCategories = {};
      for(let key in categories) {
        newCategories[key] = categories[key]
      }
      if (this.edit) {
        newCategories[this.edit] = this.editedCategory
      } else {
        let num = Object.keys(categories).length
        newCategories[++num] = this.newCategory;
      }
      this.updateCategory(newCategories);
      this.newCategory = '';
      this.editedCategory = '';
      this.edit = false; 
    },
    removeCategory(index) {
      if(this.countProductToCategory(this.RESTAURANT.settings['category_sequence'][index]) > 0) {
        this.$store.dispatch('addNewNotice', {text: i18n.global.t('restCategories.alertCategoryNotEmpty'), error: true})
      } else {
        let categories = this.RESTAURANT.settings['category_sequence']
        let newCategories = {};
        for(let key in categories) {
          newCategories[key] = categories[key]
        }
        delete newCategories[index];
        let newCategoriesChange = {}
        let num = 0;
        for (let key in newCategories) {
          newCategoriesChange[++num] = newCategories[key]
        }
        this.updateCategory(newCategoriesChange);
      }
    },
    editCategoryName(index, category) {
      if (this.countProductToCategory(category) === 0) {
        this.edit = index
        this.editedCategory = category
      } else {
        this.$store.dispatch('addNewNotice', {text: i18n.global.t('restCategories.editCategoryErr'), error: true})
      }
    },
    changeCategoryPosition(index, elem, position) {
      let categoriesArr = Object.values(this.RESTAURANT.settings['category_sequence'])
      function catObj(arr) {
        let newCategories = {}
        let num = 0
        for (let key in arr) {
          newCategories[++num] = arr[key]
        }
        return newCategories
      }
      if (position === 'up' && index > 1) {
        categoriesArr.splice(index - 1, 1)
        categoriesArr.splice(index - 2, 0, elem)
        this.updateCategory(catObj(categoriesArr))
      }
      if (position === 'down' && index < this.countCategories) {
        categoriesArr.splice(index - 1, 1)
        categoriesArr.splice([index], 0, elem)
        this.updateCategory(catObj(categoriesArr))
      }
    },
    cancellBtn() {
      this.edit = false
      this.editedCategory = ''
    },
  },
  watch: {
    newCategory() {
      if (Object.values(this.RESTAURANT.settings['category_sequence']).some(this.sameCategories)) {
        this.doubleCategory = true
      } else {
        this.doubleCategory = false
      }
    },
    editedCategory(newEl) {
      let categories = _.cloneDeep(Object.values(this.RESTAURANT.settings['category_sequence']))
      categories.splice(this.edit - 1, 1)
      let check = categories.some((element) => {
        return element.toLowerCase() === newEl.toLowerCase()
      })
      if (check) {
        this.doubledCategory = true
        this.$store.dispatch('addNewNotice', {text: i18n.global.t('restCategories.categoryAlreadyExists'), error: true})
      } else {
        this.doubledCategory = false
      }
    },
  },
  mounted() {
    //initialization bootstrap tooltips
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  }
}
</script>

<style scoped>
.flip-category-move {
  transition: transform .2s;
}
</style>
